module.exports = __webpack_public_path__ + "assets/220116aae8504d78c5906d0f1bd228c9.mp3";